import styled from 'styled-components'
import usePageContext from './Page/context'

const FloatingElements = () => {
  // Theme
  const {
    state: { theme, floatingLogosVisible },
  } = usePageContext()

  return (
    <>
      <FloatingElement1 className={`${theme === 'black' ? 'black' : ''} ${floatingLogosVisible ? '' : 'hidden'}`} />
      <FloatingElement2 className={`${theme === 'black' ? 'black' : ''} ${floatingLogosVisible ? '' : 'hidden'}`} />
    </>
  )
}

const FloatingElement1 = styled.div`
  position: fixed;
  bottom: 15px;
  left: 10px;
  width: 13px;
  height: 23px;
  background-image: url('/svgs/ab-awards-logo-only-white.svg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;

  &.black {
    background-image: url('/svgs/ab-awards-logo-only.svg') !important;
  }

  @media (min-width: 768px) {
    bottom: 25px;
    left: 20px;
    width: 23px;
    height: 42px;
    background-size: contain;
  }

  @media (min-width: 1024px) {
    bottom: 30px;
    left: 30px;
    width: 24px;
    height: 40px;
    background-size: contain;
  }
`

const FloatingElement2 = styled.div`
  position: fixed;
  bottom: 15px;
  right: 10px;
  width: 68px;
  height: 34px;
  background-image: url('/svgs/boss-logo-v2-white.svg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;

  &.black {
    background-image: url('/svgs/boss-logo-v2.svg') !important;
  }

  @media (min-width: 768px) {
    bottom: 25px;
    right: 20px;
    width: 117px;
    height: 56px;
  }

  @media (min-width: 1024px) {
    position: fixed;
    bottom: 30px;
    right: 30px;
    width: 108px;
    height: 52px;

    background-size: contain;
  }
`

export default FloatingElements